/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/prop-types */
/* eslint-disable operator-linebreak */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useContext, createContext } from 'react';
import { useTranslation } from 'react-i18next';

import { useQuery } from '@tanstack/react-query';
import BenefitsService from 'src/services/benefits.service';
import { IBenefitType } from 'src/interfaces';
import EnrollmentChangesCard from '../enrollment-changes-card';
import {
  EnrollmentChangesContainer,
  EnrollmentChangesTitle,
  EnrollmentChangesGridContainer,
  EnrollmentTypeTitle,
} from './styles';

import { benefitsCategories } from '../..';

/*
interface IStoreContext {
  benefitType: IBenefitType | null;
  benefitTypeModal: boolean;
  // eslint-disable-next-line no-unused-vars
  setSelectedBenefitType: (b: IBenefitType) => void;
  setBenefitTypeEditModal: (b: boolean) => void;
  clearSelectedBenefitType: () => void;
}

const useStore = (): IStoreContext => {
  const [benefitType, setBenefitType] = useState<IBenefitType | null>(null);
  const [benefitTypeModal, setBenefitTypeModal] = useState<boolean>(false);

  const setSelectedBenefitType = (b: IBenefitType): void => {
    setBenefitType(b);
  };

  const clearSelectedBenefitType = (): void => {
    setBenefitType(null);
  };

  const setBenefitTypeEditModal = (value: boolean): void => {
    setBenefitTypeModal(value);
  };

  return {
    benefitType,
    benefitTypeModal,
    setSelectedBenefitType,
    clearSelectedBenefitType,
    setBenefitTypeEditModal,
  };
};

const StoreContext = createContext<IStoreContext | null>(null);

export const StoreContextProvider: React.FC = ({ children }) => (
  <StoreContext.Provider value={useStore()}>{children}</StoreContext.Provider>
);

export const useBenefitType = (): IBenefitType | null => useContext(StoreContext)?.benefitType ?? null;

export const useBenefitTypeModalIsOpen = (): boolean => useContext(StoreContext)?.benefitTypeModal ?? false;

export const useClearBenefitType = (): (() => void) => useContext(StoreContext)?.clearSelectedBenefitType ?? (() => {});

// eslint-disable-next-line no-unused-vars
export const useSetBenefitType = (): ((b: IBenefitType) => void) =>
  useContext(StoreContext)?.setSelectedBenefitType ?? (() => {});

export const useSetBenefitTypeEditModal = (): ((value: boolean) => void) =>
  useContext(StoreContext)?.setBenefitTypeEditModal ?? (() => {});
*/

/*
const EnrollmentChangesStoreWrapper: React.FC<{ searchTerm: string }> = ({ searchTerm }) => (
  <StoreContextProvider>
    <EnrollmentChanges searchTerm={searchTerm} />
  </StoreContextProvider>
);
*/

const EnrollmentChanges: React.FC<{ searchTerm: string }> = ({ searchTerm }) => {
  const { t } = useTranslation();

  const itemObject: { [key: string]: IBenefitType[] } = {};

  benefitsCategories.forEach(item => {
    itemObject[item] = [];
  });

  const { data: types, refetch } = useQuery({
    queryKey: ['benefits/types'],
    queryFn: () => BenefitsService.getBenefitsTypes(searchTerm),
    enabled: true,
  });

  types?.forEach(type => {
    // Prevents backend null value error
    if (type.type && type.generalCategory && type.generalCategory?.trim() !== '') {
      if (benefitsCategories.includes(type.generalCategory)) {
        itemObject[type.generalCategory].push(type);
      }
    }
  });

  useEffect(() => {
    refetch();
  }, [searchTerm]);

  return (
    <EnrollmentChangesContainer>
      <EnrollmentChangesTitle />
      {benefitsCategories.map(category => (
        <EnrollmentChangesGridContainer key={category}>
          <EnrollmentTypeTitle>{category}</EnrollmentTypeTitle>

          {itemObject[category]?.map((item, index: number) => <EnrollmentChangesCard key={index} benefitType={item} />)}
        </EnrollmentChangesGridContainer>
      ))}
    </EnrollmentChangesContainer>
  );
};

export default EnrollmentChanges;
